Module("paginas.blog-category", function(Page) {
  "use strict";

  Page.fn.initialize = function() {
    Module.run('componentes.navbar-blog');
  };
});
